exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GIT/F300/V4/ng_formulario300v4/src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.css
// module id = ../../../../../src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.css
// module chunks = main